/**
 * WoodMart product page — gallery, variants, cart
 */
(function () {
  'use strict';

  function formatMoney(cents) {
  const fmt = (window.Shopify && window.Shopify.theme && window.Shopify.theme.moneyFormat) || 'Dhs. {{amount}}';
  const amount = (cents / 100).toFixed(2);
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, fmt);
  }
  return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
}

  function setActiveThumb(root, index) {
    root.querySelectorAll('[data-thumb-index]').forEach((btn) => {
      btn.classList.toggle('is-active', Number(btn.dataset.thumbIndex) === index);
    });
  }

  function destroyZoom(root) {
    root.querySelectorAll('[data-pdp-zoom]').forEach((figure) => {
      figure.classList.remove('is-zooming');
      figure.querySelector('.wd-pdp-zoom__lens')?.remove();
      figure._zoomBound = false;
    });
  }

  function initZoomFigure(figure) {
    if (figure._zoomBound) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const img = figure.querySelector('.wd-pdp-gallery__img');
    const zoomSrc = img?.dataset.zoomSrc;
    if (!img || !zoomSrc) return;

    const lens = document.createElement('img');
    lens.className = 'wd-pdp-zoom__lens';
    lens.src = zoomSrc;
    lens.alt = '';
    lens.setAttribute('aria-hidden', 'true');
    figure.appendChild(lens);

    const onMove = (e) => {
      const rect = figure.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const w = rect.width;
      const h = rect.height;
      const natW = lens.naturalWidth;
      const natH = lens.naturalHeight;
      if (!natW || !natH || !w || !h) return;

      const rx = natW / w;
      const ry = natH / h;

      lens.style.width = `${natW}px`;
      lens.style.height = `${natH}px`;
      lens.style.left = `${-(x * rx - w / 2)}px`;
      lens.style.top = `${-(y * ry - h / 2)}px`;
    };

    const onEnter = () => {
      const show = () => figure.classList.add('is-zooming');
      if (lens.complete && lens.naturalWidth) show();
      else lens.addEventListener('load', show, { once: true });
    };

    const onLeave = () => figure.classList.remove('is-zooming');

    figure.addEventListener('mouseenter', onEnter);
    figure.addEventListener('mousemove', onMove);
    figure.addEventListener('mouseleave', onLeave);
    figure._zoomBound = true;
  }

  function initZoom(root) {
    root.querySelectorAll('[data-pdp-zoom]').forEach(initZoomFigure);
  }

  function updateEnlargeLink(root, slideIndex) {
    const enlarge = root.querySelector('[data-pdp-enlarge]');
    const slides = root.querySelectorAll('[data-pdp-main] .swiper-slide');
    const slide = slides[slideIndex];
    if (!enlarge || !slide) return;
    const zoomSrc = slide.querySelector('.wd-pdp-gallery__img')?.dataset.zoomSrc;
    const lightbox = slide.querySelector('[data-pdp-lightbox]');
    if (zoomSrc) {
      enlarge.href = zoomSrc;
      if (lightbox) lightbox.href = zoomSrc;
    }
  }

  function initGallery(root) {
    const mainEl = root.querySelector('[data-pdp-main]');
    if (!mainEl || typeof Swiper === 'undefined') return;

    const prevEl = root.querySelector('[data-pdp-prev]');
    const nextEl = root.querySelector('[data-pdp-next]');

    destroyZoom(root);

    if (mainEl.swiper) {
      mainEl.swiper.destroy(true, true);
    }

        const galleryEl = root.querySelector('[data-pdp-gallery]');
    const initialSlide = Number(galleryEl?.dataset.initialSlide || 0);
    const slideCount = mainEl.querySelectorAll('.swiper-slide').length;

    const mainSwiper = new Swiper(mainEl, {
      initialSlide: initialSlide,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 300,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      watchOverflow: true,
      allowTouchMove: true,
      autoplay: slideCount > 1 ? {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
      on: {
        init(sw) {
          setActiveThumb(root, sw.activeIndex);
          initZoom(root);
          updateEnlargeLink(root, sw.activeIndex);
        },
        slideChange(sw) {
          setActiveThumb(root, sw.activeIndex);
          updateEnlargeLink(root, sw.activeIndex);
          root.querySelectorAll('[data-pdp-zoom].is-zooming').forEach((f) => f.classList.remove('is-zooming'));
        },
      },
    });

    root.querySelectorAll('[data-thumb-index]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const index = Number(btn.dataset.thumbIndex);
        mainSwiper.slideTo(index);
        setActiveThumb(root, index);
        if (mainSwiper.autoplay) mainSwiper.autoplay.start();
      });
    });

    root.querySelectorAll('[data-pdp-lightbox]').forEach((link) => {
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: hover)').matches) {
          e.preventDefault();
        }
      });
    });

    root.querySelector('[data-pdp-enlarge]')?.addEventListener('click', (e) => {
      e.preventDefault();
      const href = e.currentTarget.href;
      if (href) window.open(href, '_blank', 'noopener');
    });

    root._mainSwiper = mainSwiper;
  }

  function findVariant(product, selectedOptions) {
    return product.variants.find((v) =>
      selectedOptions.every((opt, i) => v['option' + (i + 1)] === opt)
    );
  }

  function getSelectedOptions(root) {
    const options = [];
    root.querySelectorAll('[data-option-index]').forEach((optEl) => {
      const selected = optEl.querySelector('.wd-pdp-swatch.is-selected');
      options.push(selected ? selected.dataset.optionValue : '');
    });
    return options;
  }

  function slideToMedia(root, mediaId) {
    const mainEl = root.querySelector('[data-pdp-main]');
    if (!mainEl?.swiper || !mediaId) return;
    const slides = mainEl.querySelectorAll('.swiper-slide[data-media-id]');
    slides.forEach((slide, i) => {
      if (String(slide.dataset.mediaId) === String(mediaId)) {
        mainEl.swiper.slideTo(i);
        setActiveThumb(root, i);
      }
    });
  }

  function updateUI(root, product, variant) {
    const priceEl = root.querySelector('[data-pdp-price]');
    const compareEl = root.querySelector('[data-pdp-compare]');
    const stockEl = root.querySelector('[data-pdp-stock]');
    const skuEl = root.querySelector('[data-pdp-sku-value]');
    const variantInput = root.querySelector('[data-variant-id]');
    const atcBtn = root.querySelector('.wd-pdp-atc');
    const buyBtn = root.querySelector('[data-buy-now]');
const titleEl = root.querySelector('[data-pdp-title]');
if (titleEl) {
  const base = titleEl.dataset.baseTitle || '';
  const storage =
    [variant.option1, variant.option2, variant.option3].find((v) =>
      /gb|tb/i.test(String(v || ''))
    ) || '';
  titleEl.textContent = storage ? `${base} - ${storage}` : base;
}
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    const saleBadge = root.querySelector('[data-pdp-sale-badge]');
    if (saleBadge) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const pct = Math.round(
          ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
        );
        saleBadge.textContent = `-${pct}%`;
        saleBadge.hidden = false;
      } else {
        saleBadge.hidden = true;
      }
    }
    if (stockEl) {
      if (variant.available) {
        stockEl.textContent = 'In stock';
        stockEl.className = 'wd-pdp__stock wd-pdp__stock--in';
      } else {
        stockEl.textContent = 'Out of stock';
        stockEl.className = 'wd-pdp__stock wd-pdp__stock--out';
      }
    }
    if (skuEl) skuEl.textContent = variant.sku || '—';
    if (variantInput) variantInput.value = variant.id;
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    if (buyBtn) buyBtn.disabled = !variant.available;

// Sticky mobile bar sync
const stickyPrice = root.querySelector('[data-sticky-price]');
const stickyOptions = root.querySelector('[data-sticky-options]');
const stickySave = root.querySelector('[data-sticky-save]');
const stickyAtc = root.querySelector('[data-sticky-atc]');
if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
if (stickyOptions) {
  stickyOptions.textContent = [variant.option1, variant.option2, variant.option3]
    .filter(Boolean)
    .join(' / ');
}
if (stickySave) {
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    const pct = Math.round(
      ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
    );
    stickySave.textContent = `-${pct}%`;
    stickySave.hidden = false;
  } else {
    stickySave.hidden = true;
  }
}
if (stickyAtc) {
  stickyAtc.disabled = !variant.available;
  stickyAtc.textContent = variant.available ? 'Add to cart' : 'Sold out';
}

const mediaId = variant.featured_media?.id || variant.featured_image?.id || variant.featured_media_id;
    if (mediaId) slideToMedia(root, mediaId);
  }

  function bindSwatches(root, product) {
    root.querySelectorAll('.wd-pdp-swatch').forEach((btn) => {
      btn.addEventListener('click', () => {
        const optEl = btn.closest('[data-option-index]');
        optEl.querySelectorAll('.wd-pdp-swatch').forEach((s) => {
          s.classList.remove('is-selected');
          s.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');

        const selected = getSelectedOptions(root);
        const variant = findVariant(product, selected);
        if (variant) updateUI(root, product, variant);
      });
    });
  }

  function bindQty(root) {
    const input = root.querySelector('[data-qty-input]');
    if (!input) return;
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  }

  function getAtcButtons(root) {
    return [root.querySelector('.wd-pdp-atc'), root.querySelector('[data-sticky-atc]')].filter(Boolean);
  }

  function setAtcState(root, state, available = true) {
    getAtcButtons(root).forEach((btn) => {
      btn.classList.remove('wd-btn--loading', 'wd-pdp-atc--added');
      if (state === 'loading') {
        btn.disabled = true;
        btn.classList.add('wd-btn--loading');
        btn.textContent = 'Adding…';
        return;
      }
      if (state === 'success') {
        btn.disabled = true;
        btn.classList.add('wd-pdp-atc--added');
        btn.textContent = 'Added!';
        return;
      }
      if (state === 'error') {
        btn.disabled = false;
        btn.textContent = 'Error';
        return;
      }
      btn.disabled = !available;
      btn.textContent = available ? 'Add to cart' : 'Sold out';
    });
  }

  async function addToCart(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
    });
    if (!res.ok) throw new Error('Add failed');
    return res.json();
  }

  function bindStickyBar(root) {
    const stickyAtc = root.querySelector('[data-sticky-atc]');
    const form = root.querySelector('[data-product-form] form');
    const mainAtc = root.querySelector('.wd-pdp-atc');
    if (!stickyAtc || !form || !mainAtc) return;

    stickyAtc.addEventListener('click', () => {
      if (stickyAtc.disabled || mainAtc.disabled) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(mainAtc);
      } else {
        mainAtc.click();
      }
    });
  }

  function bindForm(root) {
    const form = root.querySelector('[data-product-form] form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = form.querySelector('[data-variant-id]')?.value;
      const qty = parseInt(form.querySelector('[data-qty-input]')?.value || '1', 10);
      const isBuyNow = e.submitter?.hasAttribute('data-buy-now');
      const btn = e.submitter;
      if (!variantId || btn?.disabled) return;

      const original = btn?.textContent;
      const isAtc = btn?.classList.contains('wd-pdp-atc') || btn?.hasAttribute('data-sticky-atc');

      if (btn && !isAtc) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      } else if (isAtc) {
        setAtcState(root, 'loading');
      }

      try {
        await addToCart(variantId, qty);
        if (window.EnvoCommerce) {
          await window.EnvoCommerce.refreshCart();
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
        if (isBuyNow) {
          window.location.href = '/checkout';
        } else if (window.EnvoCommerce) {
          if (isAtc) {
            setAtcState(root, 'success');
            root.querySelector('[data-pdp-sticky-bar]')?.classList.add('is-added');
            if (window.matchMedia('(max-width: 768px)').matches && navigator.vibrate) {
              navigator.vibrate(40);
            }
          } else if (btn) {
            btn.textContent = 'Added!';
          }
          setTimeout(() => window.EnvoCommerce.openCart(), 350);
          setTimeout(() => {
            root.querySelector('[data-pdp-sticky-bar]')?.classList.remove('is-added');
            if (isAtc) {
              const available = !!root.querySelector('.wd-pdp__stock--in');
              setAtcState(root, 'idle', available);
            } else if (btn) {
              btn.textContent = original;
              btn.disabled = false;
            }
          }, 1500);
        } else {
          window.location.href = '/cart';
        }
      } catch {
        if (isAtc) {
          setAtcState(root, 'error');
          setTimeout(() => {
            const available = !!root.querySelector('.wd-pdp__stock--in');
            setAtcState(root, 'idle', available);
          }, 1500);
        } else if (btn) {
          btn.textContent = 'Error';
          setTimeout(() => {
            btn.textContent = original;
            btn.disabled = false;
          }, 1500);
        }
      }
    });
  }

  function initLiveVisitors(root) {
    const wrap = root.querySelector('[data-pdp-visitors]');
    const countEl = wrap?.querySelector('[data-pdp-visitors-count]');
    if (!wrap || !countEl) return;

    let min = Number(wrap.dataset.min) || 12;
    let max = Number(wrap.dataset.max) || 58;
    if (min > max) {
      const swap = min;
      min = max;
      max = swap;
    }

    let count = Math.floor(Math.random() * (max - min + 1)) + min;

    const render = () => {
      countEl.textContent = String(count);
    };

    render();

    const scheduleTick = () => {
      wrap._visitorTimer = window.setTimeout(() => {
        const direction = Math.random() < 0.52 ? 1 : -1;
        const step = Math.floor(Math.random() * 2) + 1;
        count = Math.max(min, Math.min(max, count + direction * step));
        render();
        scheduleTick();
      }, 2500 + Math.random() * 4500);
    };

    scheduleTick();
  }

  function bindShare(root) {
    const wrap = root.querySelector('[data-pdp-share]');
    if (!wrap) return;
    const toggle = wrap.querySelector('[data-pdp-share-toggle]');
    toggle?.addEventListener('click', (e) => {
      e.preventDefault();
      wrap.classList.toggle('is-open');
    });
    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) wrap.classList.remove('is-open');
    });
  }

  function init(root) {
    const dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    let product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch {
      return;
    }

        initGallery(root);
    bindSwatches(root, product);
    bindQty(root);
    bindForm(root);
    bindStickyBar(root);
    bindShare(root);
    initLiveVisitors(root);

    // Sync main image to the default selected variant on page load
    const currentId = Number(root.querySelector('[data-variant-id]')?.value);
    const currentVariant =
      product.variants.find((v) => v.id === currentId) ||
      product.variants.find((v) => v.available) ||
      product.variants[0];
    if (currentVariant) updateUI(root, product, currentVariant);
  }

  function boot() {
    const run = () => document.querySelectorAll('[data-wd-pdp]').forEach(init);
    if (typeof Swiper !== 'undefined') {
      run();
      return;
    }
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (typeof Swiper !== 'undefined' || attempts > 40) {
        clearInterval(timer);
        run();
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
